// Removed Material Design Icon imports
import { Avatar } from "antd";
// Removed useMemo import as caption logic is removed for now
// Added react-icons imports
import {
  FiMoreHorizontal, // Replaced MoreHoriz
  FiUser, // Replaced PersonOutline
  FiX, // Added X icon
} from "react-icons/fi";
// Removed CaptionExpand import
import MediaSection from "./components/MediaSection";
import { BaseSocialCardProps } from "./types";

export interface InstagramStoryCardProps extends BaseSocialCardProps {
  location?: string;
  platformId: string; // Keep platformId if needed for future story-specific features
}

const InstagramStoryCard = ({
  // Removed caption prop for now, as stories handle text differently (often overlaid)
  mediaUrls = [],
  username = "User",
  profileUrl,
  isTemplateVideo,
  // Removed postedAt prop
  // Removed platformId prop from destructuring as it's not directly used in this simplified view
}: InstagramStoryCardProps) => {
  // Removed caption limit and display logic

  // Story dimensions: 9:16 aspect ratio, limited height for preview
  // const storyWidth = 200; // Example width - Removed usage
  // const storyHeight = (storyWidth * 16) / 9; // Removed usage

  return (
    <div
      className="relative w-full aspect-[9/16] bg-black text-white rounded-lg overflow-hidden shadow-md" // Changed bg to black, text to white, Removed style, Added aspect ratio
    >
      {/* Progress Bar - Simple single bar for now */}
      <div className="absolute top-2 left-2 right-2 h-0.5 bg-white/50 rounded-full z-20"></div>

      {/* Removed style block for post hashtags */}

      {/* Media Container - Fills the entire card */}
      <div className="absolute inset-0 flex items-center justify-center">
        {" "}
        <MediaSection mediaUrls={mediaUrls} isTemplateVideo={isTemplateVideo} />
      </div>

      {/* Header - Overlay on top */}
      <div className="absolute top-0 left-0 right-0 p-3 pt-5 flex justify-between items-center z-10 bg-gradient-to-b from-black/50 to-transparent">
        {" "}
        {/* Add subtle gradient, increased top padding */}
        <div className="flex items-center gap-2">
          {/* Removed gradient border div */}
          <Avatar
            size={32} // Slightly smaller avatar?
            src={profileUrl}
            icon={!profileUrl ? <FiUser /> : undefined} // Replaced
          />
          <div className="flex items-center gap-1.5">
            {" "}
            {/* Combine username and time */}
            <span className="font-semibold text-sm text-white drop-shadow-sm">
              {username}
            </span>
            <span className="text-xs font-medium text-gray-300 drop-shadow-sm">
              {/* Simplified time indicator */}
              Now
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {" "}
          {/* Container for icons */}
          <FiMoreHorizontal className="text-white text-lg drop-shadow-sm" />{" "}
          {/* White icon */}
          <FiX className="text-white text-lg drop-shadow-sm" />{" "}
          {/* Added X icon */}
        </div>
      </div>

      {/* Removed Action Buttons Section */}
      {/* Removed Caption Section */}
      {/* Removed Timestamp Section */}
    </div>
  );
};

export default InstagramStoryCard;
